const RelaseNote: React.FC = () => {
    return (
        <div id='PrivacyPage' className='page'>
            <div className='content' id='release-note-content'>
                <dl>
                    <dt>2023-01-21</dt>
                    <dd>
                        <ul>
                            <li>データ表示で日付選択を追加</li>
                            <li>登録時のエラー処理の修正</li>
                        </ul>
                    </dd>
                </dl>
            </div>
        </div>
    );
};

export default RelaseNote;
